import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import StaffSidebar from "./StaffSidebar";
import StaffTopHeader from "./StaffTopHeader";
import "./StaffLayout.css";

function StaffLayout() {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

  useEffect(() => {
    const role = localStorage.getItem("role");
    const token = localStorage.getItem("access_token");

    if (!token || !role) {
      navigate("/Staff_Login");
      return;
    }

    if (role.toLowerCase() !== "staff") {
      navigate("/Staff_Login");
    }
  }, [navigate]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 992;
      setIsMobile(mobile);
      setIsSidebarOpen(!mobile);
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="staff-layout">
      <StaffSidebar
        isOpen={isSidebarOpen}
        isMobile={isMobile}
        onClose={() => setIsSidebarOpen(false)}
      />

      {isMobile && isSidebarOpen && (
        <div className="staff-overlay" onClick={() => setIsSidebarOpen(false)} />
      )}

      <div className={`staff-main ${isSidebarOpen && !isMobile ? "staff-sidebar-open" : "staff-sidebar-closed"}`}>
        <StaffTopHeader onToggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
        <div className="staff-content">
          <Outlet />
        </div>
        <div className="staff-footer">
          © 2025 Matrimonial. All rights reserved. <span>💖</span>
        </div>
      </div>
    </div>
  );
}

export default StaffLayout;